module.exports = __webpack_public_path__ + "img/psychological.0ae6cee4.jpg";